module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Praise for John A. Daly and "), _c('i', [_vm._v("Broken Slate")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("“John Daly has a magical writing style, and his books keep you up late at night turning pages. Sean, the protagonist, helps you see the world through his eyes in a total escape from daily life. You won’t want to put it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Dana Perino, Former White House Press Secretary")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("“Crackling with gunfire and suspense, the opening pages of BROKEN SLATE make clear that John A. Daly writes with assurance and style -- and without fear or political correctness. This third installment in the Sean Coleman series brings us an engrossing thriller, centered around a deeply flawed but compelling character: an antihero for the post-9/11 age.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— James Rosen, Fox News chief Washington correspondent and author of "), _c('i', [_vm._v("The Strong Man")]), _vm._v(" and "), _c('i', [_vm._v("Cheney One On One")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("“What a great f***ing book. Seriously... Sean Coleman is the kind of character that pisses you off—he’s emotionally broken, often thoughtless, and sometimes a jerk. He’s also loyal, honorable, and anything but a super hero. In short, John Daly’s Sean Coleman is a lot like you and me.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("—Terry Schappert, U.S. Army Special Forces, and host of Warriors, Shark Attack Survival Guide, Dude You’re Screwed!, and Hollywood Weapons: Fact or Fiction?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 66
// module chunks = 0